import Http from "./http";

export const getUserDetailsAPI = (data) => {
  return Http.post("admin/getUserProfileDetail", data);
};